/**
 * Returns the rigth currencyToDisplay Object to be used for a pricing entity
 * @param {*} globalCurrencySettings
 * @param {*} advancedCurrencySettings
 * @param {*} actualCurrencyCode
 */
const getCorrectCurrencySettings = (
  globalCurrencySettings,
  advancedCurrencySettings,
  actualCurrencyCode
) => {
  if (advancedCurrencySettings && advancedCurrencySettings[actualCurrencyCode]) {
    return advancedCurrencySettings[actualCurrencyCode];
  }
  return globalCurrencySettings;
};

export { getCorrectCurrencySettings };
